import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "../Loading/Loading";


class ChooseLesson extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lesson: [],
    };
  }
  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    // if the lesson slug matches the url params, show that lesson as something the user can click to start.
    if (params.lesson === "lessons") {
      console.log("lessons");
      this.setState({ lesson: this.props.allLessons });
    } else {
      let lesson = this.props.allLessons.filter(
        (lesson) => lesson.slug === 'meaning-making'
      );
      this.setState({ lesson: lesson });
    }
  }
  setActiveLesson = (lesson) => {
    this.props.dispatch({ type: "SET_ACTIVE_LESSON", payload: lesson });
    this.props.dispatch({ type: "SET_LESSON_DATA", payload: lesson.id });
  };
  render() {
    /// checks to see if there is anything in the activeLesson reducer
    let lesson = this.props.activeLesson;
    function isEmpty(lesson) {
      return Object.keys(lesson).length === 0;
    }
    let noActiveLesson = isEmpty(lesson);
    return (
      <main className="dark-mode">
        {noActiveLesson ? (
          <div className="content">
            <div className="flex-box flex-center">
              {this.state.lesson.map((lesson, i) => {
                return (
                  <div
                    key={i}
                    className="lesson-div-whole flex-box flex-center"
                  >
                    <div className="lesson-div flex-box flex-column column-lg-5 column-sm-12 column-md-12">
                      <img
                        src={lesson.image}
                        alt={lesson.name}
                        className="lesson-image-picker"
                      />
                      <h3 className="lesson-title-picker">{lesson.title}</h3>
                      <div className="column-lg-12 column-sm-12 column-md-12">
                        <div className="flex-box flex-center">
                          <button
                            className="button button-dark"
                            onClick={() => this.setActiveLesson(lesson)}
                          >
                            Start
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="info-div column-lg-5 column-sm-12 column-md-12">
                        <div class="info-box">
                      <p>{lesson.metadata.description}</p>
                      </div>
                      <div className="info-box-trans">
                      <p>As a result of this lesson, you will be able to:</p>
                      <ul>
                      {lesson.metadata.objectives.map((objective, i) => {
                        return <li key={i}>{objective}</li>;
                      })}
                      </ul>
                      </div>
                      <p className="flex-box">
                        {lesson.metadata.themes.map((theme, i) => {
                          return <div className="theme-keyword" key={i}>{theme} </div>;
                        })}
                      </p>
                      <p><em>This case study was developed by: {lesson.metadata.contributors.map((person, i)=>{
                          return(
                              <span key={i}>{person} </span>
                          )})}</em></p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="content">
            <Loading history={this.props.history} />
          </div>
        )}
      </main>
    );
  }
}
const mapStateToProps = (state) => ({
  allLessons: state.allLessons,
  activeLesson: state.activeLesson,
});
export default connect(mapStateToProps)(ChooseLesson);
